export default __webpack_public_path__ + "app/images/fa8dd19fa58017d8fb8077b2b55b3dac.png";